import axios from 'axios';

const BASE_URL = 'https://api.weatherstack.com';
const API_KEY = process.env.REACT_APP_WEATHERSTACK_API_KEY;

export const getCurrentWeather = async (city) => {
  try {
    const response = await axios.get(`${BASE_URL}/current`, {
      params: {
        access_key: API_KEY,
        query: city,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching current weather:', error);
    throw error;
  }
};

export const getWeatherForecast = async (city) => {
  try {
    const response = await axios.get(`${BASE_URL}/forecast`, {
      params: {
        access_key: API_KEY,
        query: city,
        forecast_days: 10,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching weather forecast:', error);
    throw error;
  }
}; 